export class InvoiceStatisticsModel {
    public InvoiceId: number;
    public TotalAmount: number;
}